// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__15P0h","left":"InfoRow_left__3pgrl"};